import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=6424d784&"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports